<template>
  <CRow>
    <CCol col="12">
      <div class="container" style="margin: 80px auto" v-if="loading">
        <LoadingMDL />
      </div>

      <CDataTable
        v-else
        :header="false"
        :items="data"
        sorter
        striped
        class="customTable"
        :fields="fields"
      >
        <template #name="{ item }">
          <td>
            <CRow
              alignHorizontal="start"
              alignVertical="center"
              class="ml-2"
              style="padding-right: 20px"
            >
              <h3
                :class="checkLangClass() + ' ' + 'm-0 '"
                style="font-size: 1.3rem"
              >
                {{ item.name.split("/")[0] }}
              </h3>
              <template v-if="lang === 'CN'">
                <h3 class="m-0 fontPinyin" style="font-size: 1.3rem">
                  {{ item.name.split("/")[1] }}
                </h3>
              </template>
            </CRow>
          </td>
        </template>
        <template #btnText="{ item }">
          <td>
            <CRow
              alignHorizontal="around"
              :class="checkLangClass() + ' ' + 'mr-2'"
            >
              <CCol lg="6" sm="12">
                <CProgress show-value height="30px" :value="100">
                  <CProgressBar
                    class="CCProgressBar"
                    :value="getProgress(item)"
                  >
                    {{ Math.trunc(progress[item.id].progress) }}%
                  </CProgressBar>
                </CProgress>
              </CCol>
              <CCol lg="6" sm="12">
                <CButton
                  :color="isAvailableButtonColor(item)"
                  shape="pill"
                  :variant="isAvailableButtonStyle(item)"
                  @click="isAvailableButtonRoute(item)"
                  >{{ isAvailableButtonText(item) }}</CButton
                >
              </CCol>

              <!-- {{ getProgress(item) }}% -->
            </CRow>
          </td>
        </template>
      </CDataTable>
    </CCol>
  </CRow>
</template>
<script>
import { mapGetters } from "vuex";
import "../../../assets/scss/_chineseStyle.scss";
import "../../../assets/scss/_chineseIcon.scss";
import LoadingMDL from "../../loading/LoadingMDL";

export default {
  name: "ChapterTable",
  props: {
    allItem: Array,
    chapterProgress: Object,
    loading: Boolean,
  },
  components: {
    LoadingMDL,
  },
  data() {
    return {
      lang: "",
      progress: [],
      data: [],
      lessonId: this.$route.params.id,
      topic: [],
      pinyin: [],
      fields: [
        "name",
        // {key: 'name'},
        { key: "btnText" },
      ],
      button: {
        color: "",
        variant: "",
        route: "",
      },
      code: this.$route.params.id,
      allTopic: [],
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: "language/getLanguage",
    }),
  },
  watch: {
    pinyin: function(val) {},
    storeLanguage: function(val) {
      this.lang = val;
      this.setNewData();
    },
    chapterProgress: function(val) {
      var allTopic = val.template.filter((item) => {
        if (item.type == "topic") {
          return item;
        }
      });
      this.progress = allTopic;
      this.allTopic = allTopic;
    },
  },
  created() {
    this.lang = this.$store.state.language.language;
    this.setNewData();
  },
  mounted() {},
  methods: {
    getProgress(data) {
      let num = Math.trunc(this.progress[data.id].progress);
      if (num !== null) {
        if (num <= 30 && num > 0) {
          return 20;
        } else if (num == 0) {
          return 10;
        } else {
          return num;
        }
      }
    },
    checktext(name) {
      return name;
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    checkPinyin(val) {
      if (val) {
        for (var i = 0; i <= val.length; i++) {
          if (val[i].key == "PIN IN") {
            var pin = val[i].value.split("：");
            return "(" + pin[1] + ")";
          }
        }
      } else {
        console.log("change language is error!!");
      }
    },
    test(testerParameters) {
      alert(JSON.stringify(testerParameters));
    },
    setNewData() {
      this.data = [];
      if (this.allItem) {
        for (var i = 0; i <= this.allItem.length; i++) {
          var item = this.allItem[i];
          if (item) {
            var name = "";
            if (this.lang === "CN") {
              var pinin = this.checkPinyin(item.title);
              var chn = this.$helpers.translate(item.title, this.lang);
              name = chn + " " + "/" + pinin;
            } else {
              name = this.$helpers.translate(item.title, this.lang);
            }
            var btn_url = item.button.action;
            var btn_text = this.$helpers.translate(item.button.text, this.lang);

            this.data.push({
              name: name,
              action: btn_url,
              btnText: btn_text,
              id: i,
            });
          }
        }
      }
    },
    linkTo(data) {},
    isAvailableButtonColor(data) {
      var locked = this.allTopic[data.id].lock;
      if (locked) {
        return "danger";
      } else {
        return "success";
      }
    },
    isAvailableButtonStyle(data) {
      var locked = this.allTopic[data.id].lock;
      if (locked) {
        return "outline";
      } else {
        return "";
      }
    },
    isAvailableButtonText(data) {
      var locked = this.allTopic[data.id].lock;
      if (locked) {
        return "Locked";
      } else {
        return "Start";
      }
    },
    isAvailableButtonRoute(data) {
      let locked = this.allTopic[data.id].lock;
      if (data.id == 0) {
        let str = data.action.split("-");
        let body = "/" + str[0] + "/" + str[1];
        this.$store.commit("necessary/setCodePage", str[1]);
        this.$router.push(body);
      } else {
        if (locked) {
        } else {
          let str = data.action.split("-");
          let body = "/" + str[0] + "/" + str[1];
          this.$store.commit("necessary/setCodePage", str[1]);
          this.$router.push(body);
        }
      }
    },
  },
};
</script>
<style scoped>
.customTable {
  border: none !important;
}
.progress {
  background-color: #99adc1;
}
.CCProgressBar {
  background-color: #4c7093;
}
</style>
